<template>
    <div v-show="store.state.currentTab === 'Export'" class="menu-content" id="export-settings">
        <h1 class="themed-title">{{t('export project title','Export your project')}}</h1>

        <div class="ul-tab-area">
            <div
                v-for="(exportArea, i) in exportAreas" :key="i"
                class="ul-tab"
                :class="chosenTab === exportArea.id ? 'ul-tab-active' : ''"
                @click="chosenTab = exportArea.id"
            >
                {{t(exportArea.translateKey, exportArea.translateDefault)}}
            </div>
        </div>

        <div class="export-form-content" v-show="chosenTab === 'exp-template-options'">
            <div class="themed-subtitle margin-bottom-20">
                {{t('text editor','PDF Text Editor')}}
                <span class="tooltip">ⓘ<span class="tooltiptext">
                    <span>{{t('text editor tip','Type your own text for the PDF export, or use the shortcodes which will generate PDF elements.')}}</span>
                </span></span>
            </div>
            <div id="export-trix-holder"></div>
            <div class="shortcode-title themed-subtitle">
                {{t('insert shortcode','Insert Shortcode')}}
            </div>
            <div class="shortcode-area">
                <span
                    class="shortcode"
                    v-for="(item, i) in shortcodes" :key="i"
                    @click="addShortcode(item)"
                >
                    {{ item }}
                </span>
            </div>
            <div class="saved-template-area" v-if="store.state.templates.length">
                <div class="themed-subtitle">{{t('my saved templates','My saved templates')}}</div>
                <table class="saved-template-table">
                    <tr
                        v-for="(template, i) in store.state.templates" :key="i"
                        @click="loadTemplate(template)"
                    >
                        <td class="template-title-col">
                            {{ template.title }}
                        </td>
                        <td @click="deleteTemplate(template)">
                            <Icon icon="delete" class="clickable-danger" />
                        </td>
                    </tr>
                </table>
            </div>
            <div class="template-button-area">
                <button @click="saveTemplate">{{t('save template','Save Template')}}</button>
            </div>
        </div>

        <div class="export-form-content" v-show="chosenTab === 'exp-beading-options'">
            <div class="form-option">
                <label><span>{{t('use custom word chart','Use custom word chart')}}</span>
                    <span class="tooltip">&nbsp;ⓘ<span class="tooltiptext">
                        <span>{{t('use custom word chart tip','Uses the contents of the text editor in the Word Chart tab.')}}</span>
                    </span></span>
                </label>
                <input type="checkbox" v-model="useCustomWordChart">
            </div>
            <div v-show="showPanelWidthArea">
                <div class="form-option">
                    <label>
                        <span>{{t('use panels','Split project into panels')}}</span>
                        <span class="tooltip">ⓘ<span class="tooltiptext">
                            <span>{{t('use panels tip','Panels split large canvases up into smaller chunks. Recommended for large projects like tapestries')}}</span>
                        </span>
                    </span></label>
                    <input type="checkbox" v-model="usePanels" @click="setTubularFalse">
                </div>
                <div class="my-highlighted-options" v-show="usePanels">
                    <label><span>{{('max panel width','Max panel width')}}</span></label>
                    <input type="number" v-model="exportStripWidth" min="10" max="100">
                </div>
            </div>
            <div class="form-option" v-show="showStartingBeadOption">
                <label>
                    <span>{{t('starting bead','Starting bead')}}</span>
                    <span class="tooltip">ⓘ<span class="tooltiptext">
                        <span>{{t('starting bead tip','This is the first bead you will pick up when making your design. For peyote, make sure your starting bead is a \'down\' bead.')}}</span>
                    </span></span>
                </label>
                <select v-model="startingBead">
                    <option
                        v-for="(item, index) in startingBeadOptions" :key="index"
                        :value="item.value"
                    >
                        {{t(item.translateKey, item.translateDefault)}}
                    </option>
                </select>
            </div>
            <div class="form-option" v-show="canSelectDirection">
                <label>{{t('beading direction','Beading direction')}}</label>
                <select v-model="beadingDirection">
                    <option value="vertical">{{t('vertical','Vertical')}}</option>
                    <option value="horizontal">{{t('horizontal','Horizontal')}}</option>
                </select>
            </div>
            <div class="form-option" v-show="showCommuteOption">
                <label>
                    {{t('alternate row direction','Alternate row direction')}}
                    <span class="tooltip">ⓘ<span class="tooltiptext">
                        <span>{{t('alternate row tip','Select this option if you work back and forth to create the project, with each row changing direction (like in brick stitch).')}}</span>
                    </span></span>
                </label>
                <input type="checkbox" v-model="shouldCommute" @click="setTubularFalse">
            </div>
            <div class="form-option" v-show="showTubularOption">
                <label>{{t('tubular peyote','Tubular peyote')}}</label>
                <input type="checkbox" v-model="tubular" @click="setPanelsAndCommuteFalse">
            </div>
            <div v-show="showDiagramSizeOptions">
                <div class="form-option">
                    <label>{{t('use small diagram','Use small diagram')}}</label>
                    <input type="checkbox" v-model="useSmallDiagram">
                </div>
            </div>
            <div class="form-option">
                <label>{{t('page size selection','Page size')}}</label>
                <select v-model="exportPageSize" @change="setPageSize">
                    <option value="Letter">{{t('letter page size','Letter')}}</option>
                    <option value="A4">{{t('A4 page size','A4')}}</option>
                </select>
            </div>
            <div class="form-option">
                <label>{{t('footer text','Footer text')}}</label>
                <input type="text" v-model="exportFooter" maxlength="200" @change="updateFooter">
            </div>
            <div class="form-option">
                <label><span>{{t('header image file input','Header Image')}}</span> <span class="tooltip">ⓘ
                    <span class="tooltiptext">{{t('header image file input tip','This image will be placed at the top-right hand corner of the first page only.')}}
                    </span>
                </span></label>
                <button type="button">
                    <label class="custom-file-button">
                        <span>{{t('header image file input','Header Image')}}</span>
                        <input class="hidden" ref="headerImage" type="file" @change="addFile" accept="image/*"/>
                    </label>
                </button>
            </div>
            <div class="form-option" v-show="headerImage !== null">
                <label>{{t('clear header image button','Clear Header Image')}}</label>
                <button type="button" @click="headerImage = null">{{t('clear header image button','Clear Header Image')}}</button>
            </div>
            <div class="form-option">
                <label><span>{{t('my images file input','My Images')}}</span> <span class="tooltip">ⓘ
                    <span class="tooltiptext">{{t('my images file input tip','You can select multiple images to add to the PDF. You will need to add a row for each image in the table above. Images will be added to your PDF in alphabetical order by file name.')}}
                    </span>
                </span></label>
                <button type="button">
                    <label class="custom-file-button">
                        <span>{{t('my images file input','My Images')}}</span>
                        <input class="hidden" ref="userImages" type="file" @change="addUserImages" accept="image/*" multiple/>
                    </label>
                </button>
            </div>
            <div v-if="userImages.length">
                <table class="saved-template-table">
                    <tr
                        v-for="(image, i) in userImages" :key="i"
                    >
                        <td class="image-title-col">
                            {{ image.name }}
                        </td>
                        <td @click="deleteImage(image)">
                            <Icon icon="delete" class="clickable-danger" />
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="export-form-content" v-show="chosenTab === 'exp-wordchart-options'">
            <div id="trix-holder"></div>
            <button class="reset-editor-button" @click="resetEditorButton">
                {{ t('reset word chart','Reset Word Chart') }}
            </button>
        </div>
        <div class="export-form-content">
            <button
                class="button success-button"
                @click="createPDF"
            >
                {{ t('create pdf button','Create PDF') }}
            </button>
            <p v-show="showWaitMessage">
                {{t('please wait message','This may take a few minutes...')}}
            </p>
        </div>
    </div>
</template>

<script>
import { settings } from '../../myapp/src/settings.js';
import { exp } from '../../myapp/src/export/export.js';
import Icon from '../Icon.vue';

export default {
    data() {
        return {
            exportAreas: [
                { id: 'exp-template-options', translateKey: 'template options area', translateDefault: 'Template' },
                { id: 'exp-beading-options', translateKey: 'options', translateDefault: 'Options' },
                { id: 'exp-wordchart-options', translateKey: 'word chart', translateDefault: 'Word Chart' }
            ],
            chosenTab: 'exp-template-options',
            useCustomWordChart: false,
            showPanelWidthArea: true,
            usePanels: false,
            exportStripWidth: 50,
            showStartingBeadOption: false,
            startingBeadOptions: [
                { value: 'topLeft', translateKey: 'top left', translateDefault: 'Top left' },
                { value: 'topRight', translateKey: 'top right', translateDefault: 'Top Right' },
                { value: 'bottomLeft', translateKey: 'bottom left', translateDefault: 'Bottom Left' },
                { value: 'bottomRight', translateKey: 'bottom right', translateDefault: 'Bottom Right' },
            ],
            startingBead: 'topLeft',
            canSelectDirection: false,
            beadingDirection: 'vertical',
            showCommuteOption: false,
            shouldCommute: false,
            tubular: false,
            showTubularOption: false,
            headerImage: null,
            userImages: [],
            exportFooter: '',
            showDiagramSizeOptions: false,
            useSmallDiagram: false,
            exportPageSize: 'Letter',
            showWaitMessage: false,
            hasSeenExportTabForThisProject: false
        }
    },
    components: { Icon },
    computed: {
        shortcodes: function () {
            const list = ['title', 'image', 'description', 'details', 'bead list', 'instructions', 'diagram', 'word chart', 'credits', 'page break'];
            return list.concat(this.userImages.map(image => image.name));
        }
    },
    methods: {
        addFile() {
            const file = this.$refs.headerImage.files[0];
            if (!file) {
                console.error('No file found');
                return;
            }
            const reader = new FileReader();

            reader.addEventListener('load', () => {
                this.headerImage = reader.result;
            }, false);

            reader.addEventListener('error', () => {
                console.error('Error reading file');
            });

            reader.readAsDataURL(file); // this triggers the 'load' event and puts the image in reader.result
        },
        addUserImages() {
            const files = this.$refs.userImages.files;

            if (!files) {
                console.error('No files found');
                return;
            }

            this.userImages = [];

            const readAndPreview = file => {
                if ( /\.(jpe?g|png|gif)$/i.test(file.name) ) {
                    const reader = new FileReader();

                    reader.addEventListener('load', () => {
                        this.userImages.push({
                            name: file.name,
                            data: reader.result
                        });
                    }, false);

                    reader.addEventListener('error', () => {
                        console.error('Error reading file');
                    });

                    reader.readAsDataURL(file);
                }
            }

            [...files].forEach(file => readAndPreview(file));

        },
        deleteImage(image) {
            this.userImages = this.userImages.filter(i => i !== image);
        },
        setTubularFalse() {
            if (this.usePanels || this.shouldCommute) this.tubular = false;
        },
        setPanelsAndCommuteFalse() {
            if (this.tubular) {
                this.usePanels = false;
                this.shouldCommute = false;
            }
        },
        initializeExportSettings() {
            // called when clicking menu gear
            this.showPanelWidthArea = settings.pattern.canSelectPanelWidth;
            this.showStartingBeadOption = settings.pattern.canSelectStartingBead;
            this.canSelectDirection = settings.pattern.canSelectDirection;
            this.showCommuteOption = settings.pattern.canSelectCommute;
            this.shouldCommute = settings.pattern.commutes;
            this.showTubularOption = settings.pattern.rotateCamera; // peyote patterns
            this.beadingDirection = settings.pattern.beadingDirection || 'vertical';
            this.tubular = false;
            this.headerImage = null;
            this.userImages = [];
            this.exportFooter = settings.preferences.footer || '';
            this.showDiagramSizeOptions = settings.pattern.canExportSmallDiagrams;
            this.useSmallDiagram = false;
            this.exportPageSize = settings.preferences.pageSize;
            this.showWaitMessage = false;
        },
        setPageSize() {
            settings.preferences.pageSize = this.exportPageSize;
            settings.update();
        },
        updateFooter() {
            settings.preferences.footer = this.exportFooter;
            settings.update();
        },
        addShortcode(item) {
            const editor = document.querySelector('[trix-id="2"]').editor;
            editor.insertString(`[${item}]`);
        },
        saveTemplate() {
            const doSave = () => {
                const state = JSON.stringify(document.querySelector('[trix-id="2"]').editor.getDocument());

                const saveObj = {
                    title: this.store.state.dialogBox.textInputValue,
                    state
                };

                const newTemplates = b3.store.state.templates.concat(saveObj)
                this.store.mySet('templates', newTemplates);
                settings.preferences.templates = newTemplates;
                settings.update();
                b3.hideModal();
            };

            const prompt = this.t('name template prompt', 'Enter name of template');

            b3.renderModal(prompt, doSave, null, true);
        },
        loadTemplate(template) {
            if (!this.store.state.templates.length) return;
            const doc = JSON.parse(template.state);
            document.querySelector('[trix-id="2"]').editor.loadJSON({document: doc});
        },
        deleteTemplate(template) {
            const doDelete = () => {

                const newTemplates = b3.store.state.templates.filter(e => e !== template);
                this.store.mySet('templates', newTemplates);
                settings.preferences.templates = newTemplates;
                settings.update();
                b3.hideModal();
            };

            const prompt = this.t('delete template warning', 'Delete template: ');

            b3.renderModal(`${prompt} ${template.title}?`, doDelete, null, false);
        },
        clearWaitMessage() {
            this.showWaitMessage = false;
        },
        setExportOptions() {
            b3.exportOptions = {
                useCustomWordChart: this.useCustomWordChart,
                usePanels: this.usePanels,
                exportStripWidth: this.exportStripWidth,
                startingBead: this.startingBead,
                beadingDirection: this.beadingDirection,
                shouldCommute: this.shouldCommute,
                tubular: this.tubular,
                headerImage: this.headerImage,
                userImages: this.userImages,
                exportFooter: this.exportFooter,
                useSmallDiagram: this.useSmallDiagram,
                exportPageSize: this.exportPageSize
            };
        },
        resetEditorButton() {
            b3.resetEditorButton();
        },
        resetPDFEditor() {
            const element = document.querySelector('[trix-id="2"]');
            if (!element) return;
            const editor = element.editor;

            const myHTML = `
                <h1>[title]</h1>
                [image]<br>
                [description]<br>
                [bead list]<br>
                [instructions]<br>
                [diagram]<br>
                [word chart]<br>
                [credits]
            `;

            editor.loadHTML(''); // clears the editor
            editor.setSelectedRange(0);
            editor.insertHTML(myHTML);
        },
        createPDF() {
            this.showWaitMessage = true;

            setTimeout(() => {
                this.setExportOptions();
                const myPDF = exp.pdf({options: b3.exportOptions});
                if (myPDF) myPDF.download(`${settings.title}.pdf`);
                this.showWaitMessage = false;
            }, 10);
        }
    },
    mounted() {
        this.ee.on('launchMenu', () => {
            if (!settings.pattern) return; // when app first launches
            if (!this.hasSeenExportTabForThisProject) {
                this.initializeExportSettings();
                this.setExportOptions();
                exp.resetEditor();
                this.resetPDFEditor();
                this.hasSeenExportTabForThisProject = true;
            }
        });
        this.ee.on('newProject', () => {
            this.hasSeenExportTabForThisProject = false;
        });
        this.ee.on('clearWaitMessage', () => {
            this.clearWaitMessage();
        });
    }
}
</script>

<style lang="scss">
@import '../../assets/colors.scss';
.shortcode-area {
    background-color: white;
    padding: 10px;
    margin: 20px 0;
    border-radius: 5px;
    .shortcode {
        color: white;
        background-color: $dark_grey;
        border-radius: 5px;
        display: inline-block;
        margin: 5px;
        padding: 5px 10px;
        &:hover {
            cursor: pointer;
            background-color: $b_theme_hover;
        }
    }
}
.themed-subtitle {
    font-weight: bold;
    color: $b_theme_hover;
}
.margin-bottom-20 {
    margin-bottom: 20px;
}
.shortcode-title {
    margin-top: 20px;
}
.template-button-area {
    button {
        margin-right: 10px;
    }
}
.saved-template-table {
    margin: 15px 0;
    .template-title-col {
        min-width: 200px;
        &:hover {
            background-color: white;
            cursor: pointer;
        }
    }
    .image-title-col {
        min-width: 200px;
    }
}
</style>